// extracted by mini-css-extract-plugin
export var container = "_pd-0";
export var dotAnimation = "_pd-2";
export var dotsLoading = "_pd-1";